import { useLang } from "../contexts/LanguageContext";
import { CONTACT } from "../i18n";

function WhatsAppGlyph({ size = 22 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M19.11 17.36c-.27-.13-1.6-.79-1.84-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.16-1.33-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.63 1.11 2.81.14.18 1.93 2.94 4.67 4.13.65.28 1.16.45 1.56.58.65.21 1.25.18 1.72.11.52-.08 1.6-.65 1.83-1.27.23-.62.23-1.16.16-1.27-.07-.11-.25-.18-.52-.31zM16 4C9.37 4 4 9.37 4 16c0 2.13.56 4.13 1.55 5.86L4 28l6.32-1.66A11.93 11.93 0 0 0 16 28c6.63 0 12-5.37 12-12S22.63 4 16 4zm0 22a9.93 9.93 0 0 1-5.06-1.38l-.36-.21-3.75.98 1-3.66-.24-.38A9.96 9.96 0 0 1 6 16c0-5.51 4.49-10 10-10s10 4.49 10 10-4.49 10-10 10z"
      />
    </svg>
  );
}

// Minimal circular floating WhatsApp action button.
// Cyan accent matches the site UI; cyan glow on hover.
export default function WhatsAppFab() {
  const { t, lang } = useLang();
  const number = CONTACT.whatsapp;
  const text =
    lang === "ar"
      ? "مرحبًا Wosol Tech، أرغب بالتواصل معكم بشأن خدماتكم."
      : "Hello Wosol Tech, I'd like to get in touch about your services.";
  const href = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label={t.nav.whatsapp}
      title={t.nav.whatsapp}
      className="group fixed z-[60] bottom-5 left-5 inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#0A1428] text-[#00F0FF] border border-[#00F0FF]/40 hover:border-[#00F0FF] hover:bg-[#0A1428] transition-all shadow-[0_0_0_1px_rgba(0,240,255,0.15),0_8px_24px_rgba(0,0,0,0.6)] hover:shadow-[0_0_0_1px_#00F0FF,0_0_24px_rgba(0,240,255,0.45)]"
    >
      {/* soft pulse ring */}
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full wt-pulse"
        style={{
          boxShadow: "0 0 0 0 rgba(0,240,255,0.25)",
          background:
            "radial-gradient(circle, rgba(0,240,255,0.12) 0%, rgba(0,240,255,0) 70%)",
        }}
      />
      <WhatsAppGlyph size={22} />
    </a>
  );
}
